import { addedToBasketNotification } from './added-to-basket-notification';
import { addedToBasketNotificationPane } from './added-to-basket-notification-pane';
import { bannerWithButton } from './banner-with-button';
import { checkout } from './checkout';
import { horizontalScrollablePanelProductsOnTheWay } from './horizontal-products-on-the-way';
import { horizontalScrollablePanelBoughtThisSeason } from './horizontal-scrollable-panel-bought-this-season';
import { horizontalScrollablePanelFromList } from './horizontal-scrollable-panel-from-list';
import { searchProducts } from './search-products';
import { spotlight } from './spotlight';
import { squarePanelFromRecommendationsBestPerformingArticles } from './square-panel-best-performing-articles';
import { squarePanelFromRecommendationsBestPerformingArticlesGlobal } from './square-panel-best-performing-articles-global';
import { squarePanelFromList } from './square-panel-from-list';
import { squarePanelFromListSingleProduct } from './square-panel-from-list-single-product';
import { squarePanelFromSearch } from './square-panel-from-search';

export const puma = {
  addedToBasketNotification,
  addedToBasketNotificationPane,
  checkout,
  spotlight,
  squarePanelFromList,
  squarePanelFromListSingleProduct,
  horizontalScrollablePanelBoughtThisSeason,
  horizontalScrollablePanelFromList,
  squarePanelFromRecommendationsBestPerformingArticles,
  squarePanelFromRecommendationsBestPerformingArticlesGlobal,
  searchProducts,
  squarePanelFromSearch,
  bannerWithButton,
  horizontalScrollablePanelProductsOnTheWay,
};
